import React from "react";
import { InputRangeRow } from "./index";
// Used by Hacoba NSA-HS machine

export default function TimeConveyorRow() {
   return (
      <InputRangeRow
         titleProp={"Time Conveyor"}
         descriptionProp={"sec"}
         sizeProp={4}
         typeProp={"text"}
         minProp={0}
         maxProp={10}
         propertyNameProp={"timeConveyor"}
         errorDialogueProp={"0.00-10.00 only"}
         floatProp={true}
      />
   );
}
